import { render, staticRenderFns } from "./rateList.vue?vue&type=template&id=29389fb6&scoped=true"
import script from "./rateList.vue?vue&type=script&lang=js"
export * from "./rateList.vue?vue&type=script&lang=js"
import style0 from "./rateList.vue?vue&type=style&index=0&id=29389fb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29389fb6",
  null
  
)

export default component.exports